import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Router, Route } from "react-router-dom";

import { getStore } from "./store/configureStore";
import { getHistory } from './util/configureHistory';

import * as settings from "./actions/settingActions";
import * as layout from "./actions/layoutActions";

import * as reference from "./actions/referentieActions";

import "../css/site.css";
import "../css/nado.css";
import "../css/FlandersArtSans-Black.woff";
import "../css/FlandersArtSans-Bold.woff";
import "../css/FlandersArtSans-Italic.woff";
import "../css/FlandersArtSans-Medium.woff";
import "../css/FlandersArtSans-Regular.woff";
import "../node_modules/toastr/build/toastr.min.css";

import App from "../js/components/App";

const store = getStore();
const history = getHistory();

store.dispatch(settings.loadSettings());
store.dispatch(layout.loadDefaultLayout());
store.dispatch(reference.loadReferences());

render(
	<Provider store={store}>
		<Router history={history}>
			<Route path={store.getState().settings.siteRoot} component={App} />
		</Router >
	</Provider>, document.getElementById('app')
);